const convertPremiumToCSS = (premium) => ({
    '--premium-base-default': premium.base.default,
    '--premium-base-action': premium.base.action,
    '--premium-base-active': premium.base.active,
    '--premium-base-active-action': premium.base.activeAction,
    '--premium-text-default': premium.text.default,
    '--premium-text-action': premium.text.action,
    '--premium-text-active': premium.text.active,
    '--premium-text-active-action': premium.text.activeAction,
});
const convertPremiumToObject = (premium) => ({
    premiumBaseDefault: premium.base.default,
    premiumBaseAction: premium.base.action,
    premiumBaseActive: premium.base.active,
    premiumBaseActiveActive: premium.base.activeAction,
    premiumTextDefault: premium.text.default,
    premiumTextAction: premium.text.action,
    premiumTextActive: premium.text.active,
    premiumTextActiveAction: premium.text.activeAction,
});
const Premium = {
    base: {
        default: 'var(--premium-base-default)',
        action: 'var(--premium-base-action)',
        active: 'var(--premium-base-active)',
        activeAction: 'var(--premium-base-active-action)',
    },
    text: {
        default: 'var(--premium-text-default)',
        action: 'var(--premium-text-action)',
        active: 'var(--premium-text-active)',
        activeAction: 'var(--premium-text-active-action)',
    },
};

export { Premium, convertPremiumToCSS, convertPremiumToObject };
